<app-page-header header="agreements.title" />
<qbe-panel-component>
  <div class="page-container">
    <app-agreements>
      <p nxCopytext="normal" class="nx-margin-bottom-2xs">
        <b>{{'agreements.declare'+ (remoteKindSuffix$ | async) | translate }}</b>
      </p>
      <p nxCopytext="normal" class="agreements-form_copy">
        {{ 'agreements.declaration' | translate }}
      </p>
    </app-agreements>
  </div>
</qbe-panel-component>

<div class="page-navigation nx-margin-top-2m">
  <div class="navigation-price" *ngIf="(offerValue$ | async)">
    <p nxCopytext="normal" class="nx-margin-right-xs">
      {{ 'navigation.offer_price' | translate }}
    </p>
    <h3 nxHeadline="subsection-large" class="nx-margin-right-s">
      <b>
        {{ (offerValue$ | async) || 0 | aztCurrency : 'PLN' }}
      </b>
    </h3>
  </div>
  <button nxButton (click)="goToPayments()">{{ 'agreements.navigation.next' + (remoteKindSuffix$ | async) | translate }}</button>
</div>